<template>
  <div>
    <div class="mr-5 searchHolder" style="width: 100%;">
      <!-- <google-custom-search /> -->
      <h2 class="pl-3 mt-md-2 wide pt-2 ml-lg-3 mr-lg-3">Search Results</h2>
      <div ref="searchContainer" class="ml-lg-3 mr-lg-3"></div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    this.loadGoogleCustomSearch();
  },
  methods: {
    loadGoogleCustomSearch() {
      const cx = process.env.VUE_APP_CX;
      const gcseScript = document.createElement('script');
      gcseScript.type = 'text/javascript';
      gcseScript.async = true;
      gcseScript.src = `https://cse.google.com/cse.js?cx=${cx}`;

      document.head.appendChild(gcseScript);

      gcseScript.onload = () => {

        this.$refs.searchContainer.innerHTML = '<gcse:search></gcse:search>';

        this.$nextTick(() => {
          setTimeout(() => {
            const searchInput = document.getElementById('gsc-i-id1');

            if (searchInput) {
            searchInput.placeholder = 'Search';
            document.getElementById("gsc-iw-id1").style.display = 'none';
            document.querySelector("td .gsc-search-button-v2").style.display = 'none';
            }
          }, 100);
        });
      };
    },
    
  },
};
</script>

<style lang="scss" scoped>
  h2.wide {
    background: rgb(255, 255, 255);
    margin-bottom: 0px;
  }
</style>
